import { searchCategoryDetail } from "JS/API";
import { useEffect, useRef, useState } from "react";
import { 
  FaSearch, 
  FaChevronDown, 
  FaChevronUp, 
  FaTimes, 
  FaCopy, 
  FaTrash,
  FaListAlt,
  FaClipboard
} from "react-icons/fa";
import { IoCloseOutline } from "react-icons/io5";

const RequestReviewFloating = ({ setEnterFloatSideBar }) => {
  const SESSION_KEYS = {
    USED_MARK_CLASSES: "sidebar_usedMarkClasses",
    PRODUCT_LIST: "sidebar_productList",
    SEARCH_KEYWORD: "sidebar_searchKeyword",
    SELECTED_CATEGORY: "sidebar_selectedCategory",
    FOCUSED_PRODUCT_INDEX: "sidebar_focusedProductIndex",
  };

  // 스타일 정의
  const styles = {
    container: {
      position: "fixed",
      right: "0",
      bottom: "0",
      height: "100vh",
      backgroundColor: "#ffffff",
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      boxShadow: "-8px 0 30px rgba(0, 0, 0, 0.15)",
      border: "1px solid #e2e8f0",
      borderRadius: "12px 0 0 0",
      width: "420px"
    },
    header: {
      padding: "20px 24px",
      backgroundColor: "#1e293b",
      color: "#ffffff",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      fontSize: "16px",
      fontWeight: "600",
      borderRadius: "12px 0 0 0"
    },
    headerButton: {
      background: "none",
      border: "none",
      color: "#ffffff",
      cursor: "pointer",
      padding: "8px",
      borderRadius: "6px",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    categorySelect: {
      padding: "8px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      color: "#1f2937",
      minWidth: "100px"
    },
    selectedProductSection: {
      padding: "20px 24px",
      backgroundColor: "#f8fafc",
      borderBottom: "1px solid #e2e8f0"
    },
    sectionTitle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "12px"
    },
    title: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#374151",
      display: "flex",
      alignItems: "center",
      gap: "6px"
    },
    buttonGroup: {
      display: "flex",
      gap: "8px"
    },
    button: {
      padding: "6px 12px",
      border: "none",
      borderRadius: "6px",
      fontSize: "12px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "all 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "4px"
    },
    copyButton: {
      backgroundColor: "#3b82f6",
      color: "#ffffff"
    },
    resetButton: {
      backgroundColor: "#dc2626",
      color: "#ffffff"
    },
    textarea: {
      width: "100%",
      height: "100px",
      padding: "12px 16px",
      border: "1px solid #d1d5db",
      borderRadius: "8px",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      resize: "none",
      fontFamily: "inherit",
      transition: "border-color 0.2s ease",
      boxSizing: "border-box",
      color: "#1f2937"
    },
    searchSection: {
      padding: "20px 24px",
      borderBottom: "1px solid #e2e8f0",
      backgroundColor: "#ffffff"
    },
    searchInputGroup: {
      display: "flex",
      gap: "8px",
      marginBottom: "12px"
    },
    searchInput: {
      flex: 1,
      padding: "10px 12px",
      border: "1px solid #d1d5db",
      borderRadius: "6px",
      fontSize: "14px",
      transition: "border-color 0.2s ease",
      outline: "none"
    },
    searchButton: {
      padding: "10px 16px",
      backgroundColor: "#3b82f6",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      display: "flex",
      alignItems: "center",
      gap: "6px"
    },
    resetSearchButton: {
      padding: "10px 16px",
      backgroundColor: "#6b7280",
      color: "#ffffff",
      border: "none",
      borderRadius: "6px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      transition: "background-color 0.2s ease",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px"
    },
    resultSection: {
      flex: 1,
      overflow: "auto",
      backgroundColor: "#ffffff"
    },
    resultTable: {
      width: "100%",
      borderCollapse: "collapse",
      fontSize: "12px"
    },
    resultTh: {
      padding: "12px 16px",
      backgroundColor: "#f1f5f9",
      borderBottom: "2px solid #cbd5e1",
      fontSize: "11px",
      fontWeight: "600",
      color: "#374151",
      textAlign: "left",
      textTransform: "uppercase",
      letterSpacing: "0.05em"
    },
    resultTd: {
      padding: "12px 16px",
      borderBottom: "1px solid #e2e8f0",
      verticalAlign: "top",
      fontSize: "13px",
      color: "#1e293b"
    },
    categoryHeader: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      cursor: "pointer",
      padding: "8px 12px",
      backgroundColor: "#f8fafc",
      borderRadius: "6px",
      border: "1px solid #e2e8f0",
      transition: "all 0.2s ease"
    },
    categoryCode: {
      fontSize: "11px",
      fontWeight: "600",
      color: "#374151",
      marginBottom: "2px"
    },
    toggleIcon: {
      fontSize: "10px",
      color: "#6b7280"
    },
    productItem: {
      cursor: "pointer",
      padding: "4px 8px",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      display: "inline-block",
      margin: "2px 4px 2px 0",
      fontSize: "12px",
      border: "1px solid transparent"
    },
    loadingText: {
      textAlign: "center",
      padding: "16px",
      color: "#6b7280",
      fontSize: "14px",
      fontStyle: "italic"
    }
  };

  const getFromSession = (key, defaultValue) => {
    try {
      const saved = sessionStorage.getItem(key);
      return saved ? JSON.parse(saved) : defaultValue;
    } catch (error) {
      console.error("세션스토리지 읽기 오류:", error);
      return defaultValue;
    }
  };

  const saveToSession = (key, value) => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("세션스토리지 저장 오류:", error);
    }
  };

  const [usedMarkClasses, setUsedMarkClasses] = useState(() =>
    getFromSession(SESSION_KEYS.USED_MARK_CLASSES, "")
  );
  const [productList, setProductList] = useState(() =>
    getFromSession(SESSION_KEYS.PRODUCT_LIST, [{ category: "", items: "" }])
  );
  const [searchKeyword, setSearchKeyword] = useState(() =>
    getFromSession(SESSION_KEYS.SEARCH_KEYWORD, "")
  );
  const [selectedCategory, setSelectedCategory] = useState(() =>
    getFromSession(SESSION_KEYS.SELECTED_CATEGORY, "")
  );
  const [focusedProductIndex, setFocusedProductIndex] = useState(() =>
    getFromSession(SESSION_KEYS.FOCUSED_PRODUCT_INDEX, 0)
  );

  const [categoryData, setCategoryData] = useState([]);
  const [openGroups, setOpenGroups] = useState({});
  const [offsets, setOffsets] = useState({});
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const resultWrapRef = useRef();
  const limit = 5;

  useEffect(() => {
    saveToSession(SESSION_KEYS.USED_MARK_CLASSES, usedMarkClasses);
  }, [usedMarkClasses]);

  useEffect(() => {
    saveToSession(SESSION_KEYS.PRODUCT_LIST, productList);
  }, [productList]);

  useEffect(() => {
    saveToSession(SESSION_KEYS.SEARCH_KEYWORD, searchKeyword);
  }, [searchKeyword]);

  useEffect(() => {
    saveToSession(SESSION_KEYS.SELECTED_CATEGORY, selectedCategory);
  }, [selectedCategory]);

  useEffect(() => {
    saveToSession(SESSION_KEYS.FOCUSED_PRODUCT_INDEX, focusedProductIndex);
  }, [focusedProductIndex]);

  useEffect(() => {
    const savedUsedMarkClasses = getFromSession(SESSION_KEYS.USED_MARK_CLASSES, "");
    const savedSearchKeyword = getFromSession(SESSION_KEYS.SEARCH_KEYWORD, "");

    if (savedUsedMarkClasses) {
      loadCategoryData(savedUsedMarkClasses, savedSearchKeyword);
    }
  }, []);

  useEffect(() => {
    if (selectedCategory && categoryData[selectedCategory]) {
      const groupKeys = Object.keys(categoryData[selectedCategory]);
      const openState = {};
      groupKeys.forEach((key) => {
        openState[key] = true;
      });
      setOpenGroups(openState);
    }
  }, [categoryData, selectedCategory]);

  useEffect(() => {
    if (usedMarkClasses) {
      loadCategoryData(usedMarkClasses, searchKeyword);
      setSelectedCategory(usedMarkClasses);
    }
  }, [usedMarkClasses]);

  useEffect(() => {
    const el = resultWrapRef.current;
    if (!el || !hasMore || isLoading) return;

    if (el.scrollHeight <= el.clientHeight) {
      setIsLoading(true);
      loadCategoryData(selectedCategory, searchKeyword, true).finally(() => {
        setIsLoading(false);
      });
    }
  }, [categoryData, selectedCategory, hasMore]);

  const clearSessionData = () => {
    Object.values(SESSION_KEYS).forEach((key) => {
      sessionStorage.removeItem(key);
    });
  };

  const handleProductChange = (index, field, value) => {
    setSearchKeyword("");
    const updated = [...productList];
    updated[index][field] = value;
    setProductList(updated);

    if (field === "category") {
      const numericCategory = value.replace("류", "").padStart(2, "0");
      setSelectedCategory(numericCategory);
      setFocusedProductIndex(index);
      loadCategoryData(numericCategory);
    }
  };

  const handleAddItemToTextarea = (index, itemToAdd) => {
    setProductList((prev) => {
      const updated = [...prev];
      const currentItems = updated[index].items;
      const itemList = currentItems.split(",").map((item) => item.trim());

      if (!itemList.includes(itemToAdd)) {
        updated[index].items = currentItems
          ? `${currentItems}, ${itemToAdd}`
          : itemToAdd;
      }

      return updated;
    });
  };

  const toggleGroupOpen = (groupKey) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupKey]: !prev[groupKey],
    }));
  };

  const normalizeSearchResult = (dataArray) => {
    const result = {};
    dataArray.forEach((group) => {
      const code = group.similar_code;
      const items = group.products;

      if (code && Array.isArray(items)) {
        result[code] = items;
      }
    });
    return result;
  };

  const handleSearch = () => {
    if (!usedMarkClasses) {
      alert("먼저 상품분류(류)를 선택해 주세요.");
      return;
    }
    loadCategoryData(usedMarkClasses, searchKeyword);
  };

  const loadCategoryData = async (category = usedMarkClasses, keyword = "", isLoadMore = false) => {
    const key = `${category}_${keyword}`;
    const currentOffset = isLoadMore ? offsets[key] || 0 : 0;

    try {
      const res = await searchCategoryDetail(currentOffset, limit, category, keyword);
      const raw = res?.data?.data || [];
      const normalized = normalizeSearchResult(raw);

      setCategoryData((prev) => ({
        ...prev,
        [category]: isLoadMore
          ? { ...prev[category], ...normalized }
          : normalized,
      }));

      if (raw.length === 0 || Object.keys(normalized).length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setOffsets((prev) => ({
          ...prev,
          [key]: currentOffset + limit,
        }));
      }
    } catch (err) {
      console.error("유사군 데이터 불러오기 실패:", err);
      alert("유사군 항목을 불러오는 중 오류가 발생했습니다.");
    }
  };

  const handleScroll = () => {
    const el = resultWrapRef.current;
    if (!el || isLoading || !hasMore) return;

    const { scrollTop, scrollHeight, clientHeight } = el;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setIsLoading(true);
      loadCategoryData(selectedCategory, searchKeyword, true).finally(() => {
        setIsLoading(false);
      });
    }
  };

  const handleCopyClipBoard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert("클립보드에 링크가 복사되었습니다.");
    } catch (e) {
      alert("복사에 실패하였습니다");
    }
  };

  const handleCloseSidebar = () => {
    setEnterFloatSideBar(false);
  };

  const handleResetAll = () => {
    const isConfirmed = window.confirm("모든 데이터를 초기화하시겠습니까?");
    if (isConfirmed) {
      clearSessionData();
      setUsedMarkClasses("");
      setProductList([{ category: "", items: "" }]);
      setSearchKeyword("");
      setSelectedCategory("");
      setFocusedProductIndex(0);
      setCategoryData([]);
    }
  };

  return (
    <div style={styles.container}>
      {/* 헤더 */}
      <div style={styles.header}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <FaListAlt />
          <span>상품 검토 요청</span>
          <select
            style={styles.categorySelect}
            value={usedMarkClasses}
            onChange={(e) => {
              const value = e.target.value;
              setUsedMarkClasses(value);
              setSelectedCategory(value);
            }}
          >
            <option value="">선택</option>
            {Array.from({ length: 45 }, (_, i) => i + 1).map((num) => (
              <option key={num} value={num}>
                {num}류
              </option>
            ))}
          </select>
        </div>
        <button
          style={styles.headerButton}
          onClick={handleCloseSidebar}
          onMouseEnter={(e) => e.target.style.backgroundColor = 'rgba(255,255,255,0.1)'}
          onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
        >
          <IoCloseOutline size={20} />
        </button>
      </div>

      {/* 선택상품 섹션 */}
      <div style={styles.selectedProductSection}>
        <div style={styles.sectionTitle}>
          <div style={styles.title}>
            <FaClipboard />
            선택상품
          </div>
          <div style={styles.buttonGroup}>
            <button
              style={{...styles.button, ...styles.resetButton}}
              onClick={handleResetAll}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#b91c1c'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#dc2626'}
            >
              <FaTrash />
              전체초기화
            </button>
            <button
              style={{...styles.button, ...styles.copyButton}}
              onClick={() => {
                handleCopyClipBoard(productList[focusedProductIndex]?.items);
              }}
              onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
              onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
            >
              <FaCopy />
              복사
            </button>
          </div>
        </div>
        <textarea
          style={styles.textarea}
          value={productList[focusedProductIndex]?.items || ""}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}
          onFocus={(e) => {
            setSearchKeyword("");
            e.target.style.borderColor = '#3b82f6';
            e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
          }}
          onBlur={(e) => {
            e.target.style.borderColor = '#d1d5db';
            e.target.style.boxShadow = 'none';
          }}
          onChange={(e) =>
            handleProductChange(focusedProductIndex, "items", e.target.value)
          }
          placeholder="선택된 상품이 여기에 표시됩니다.&#10;아래 검색 결과에서 상품을 클릭하여 추가하세요."
        />
      </div>

      {/* 검색 섹션 */}
      <div style={styles.searchSection}>
        <div style={styles.searchInputGroup}>
          <input
            type="text"
            style={styles.searchInput}
            value={searchKeyword}
            onChange={(e) => setSearchKeyword(e.target.value)}
            placeholder="항목 검색"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch();
              }
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#3b82f6';
              e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#d1d5db';
              e.target.style.boxShadow = 'none';
            }}
          />
          <button
            style={styles.searchButton}
            onClick={handleSearch}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#2563eb'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#3b82f6'}
          >
            <FaSearch />
          </button>
        </div>
        
        <button
          style={styles.resetSearchButton}
          onClick={() => {
            setSearchKeyword("");
            loadCategoryData(selectedCategory);
          }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#4b5563'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#6b7280'}
        >
          <FaTimes />
          초기화
        </button>
      </div>

      {/* 검색 결과 */}
      <div
        style={styles.resultSection}
        ref={resultWrapRef}
        onScroll={handleScroll}
      >
        <table style={styles.resultTable}>
          <thead>
            <tr>
              <th style={{...styles.resultTh, width: '100px'}}>유사군</th>
              <th style={{...styles.resultTh, width: '300px'}}>세부항목</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(categoryData[selectedCategory] || {}).map(([groupCodes, items]) => {
              const isGroupOpen = openGroups[groupCodes];

              return (
                <tr key={groupCodes}>
                  <td style={styles.resultTd}>
                    <div
                      style={{
                        ...styles.categoryHeader,
                        ...(isGroupOpen && {
                          backgroundColor: '#eff6ff',
                          borderColor: '#bfdbfe'
                        })
                      }}
                      onClick={() => toggleGroupOpen(groupCodes)}
                      onMouseEnter={(e) => {
                        if (!isGroupOpen) {
                          e.target.style.backgroundColor = '#f1f5f9';
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isGroupOpen) {
                          e.target.style.backgroundColor = '#f8fafc';
                        }
                      }}
                    >
                      <div>
                        {groupCodes.split(",").map(code => (
                          <div key={code} style={styles.categoryCode}>
                            {code}
                          </div>
                        ))}
                      </div>
                      <div style={styles.toggleIcon}>
                        {isGroupOpen ? <FaChevronUp /> : <FaChevronDown />}
                      </div>
                    </div>
                  </td>

                  <td style={styles.resultTd}>
                    {isGroupOpen && items.map((item, idx) => (
                      <span
                        key={idx}
                        style={styles.productItem}
                        onClick={() => {
                          if (focusedProductIndex !== -1) {
                            handleAddItemToTextarea(focusedProductIndex, item);
                          } else {
                            alert("등록상품을 먼저 선택해 주세요.");
                          }
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.backgroundColor = '#eff6ff';
                          e.target.style.borderColor = '#bfdbfe';
                          e.target.style.color = '#3b82f6';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.backgroundColor = 'transparent';
                          e.target.style.borderColor = 'transparent';
                          e.target.style.color = 'inherit';
                        }}
                      >
                        {item}
                        {idx < items.length - 1 ? ", " : ""}
                      </span>
                    ))}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        
        {isLoading && (
          <div style={styles.loadingText}>
            로딩 중...
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestReviewFloating;